import adminApi from './api';
import authService from './authService';
const token = authService.getToken();

// Create a new blog
export const createBlog = async (formData) => {
    try {
        const response = await adminApi.post('/blog/create', formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Get all blogs
export const getBlogs = async (params = {}) => {
    try {
        const response = await adminApi.get('/blog', { params });
        return response.data;

        /*return await adminApi.get('/blogs', {
            headers: {
            'Authorization': `Bearer ${token}`,
            },
            params,
        });*/
    }
    catch (error) {
        throw error;
    }
}

// Get blog by ID
export const getBlogById = async (id) => {
    try {
        const response = await adminApi.get(`/blog/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;

        /*return await adminApi.get(`/blog/${id}`, {
            headers: {
            'Authorization': `Bearer ${token}`,
            },
        });*/
    }
    catch (error) {
        throw error;
    }
}

// Update blog by ID
export const updateBlog = async (id, formData) => {
    try {
        const response = await adminApi.put(`/blog/${id}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
        
        /*return await adminApi.put(`/blog/${id}`, formData, {
            headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
            },
        });*/
    } catch (error) {
        throw error;
    }
}

// Delete blog by ID
export const deleteBlog = async (id) => {
    try {
        const response = await adminApi.delete(`/blog/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;


        /*return await adminApi.delete(`/blog/${id}`, {
            headers: {
            'Authorization': `Bearer ${token}`,
            },
        });*/
    } catch (error) {
        throw error;
    }
}

export const updateBlogStatus = async (id, status) => {
  try {
    const response = await adminApi.patch(`/blog/${id}/status`, { status }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};